angular.module('assets')
    .controller('AssetSettingsController', function ($scope, toastr, $uibModalInstance, ModuleSettings, AssetSettingsLoader, data, User) {
        this.$onInit = () => {
            this.item = data;
        }

        this.cancel = () => $uibModalInstance.dismiss('Canceled');

        this.save = () => {
            return ModuleSettings.save({module: "asset"}, this.item).$promise
                .then(saved => {
                    toastr.success("Zapisano ustawienia");
                    $uibModalInstance.close(saved);
                    AssetSettingsLoader.isSupervisor(true);
                });
        }

        this.refreshUsers = q => {
            if (!this.usersLoading) {
                this.usersLoading = true;
                User.autocomplete({q: q}).$promise.then(items => {
                    this.users = items;
                    this.usersLoading = false;
                });
            }
        };
    })
